import { Card, FileDropzone } from "@bruntworkwear-apps/ui";
import type { ReceiptSource } from "@/shared/api";
import styles from "../UploadForm.module.css";

interface ReceiptDropzonesProps {
  wcSource: ReceiptSource;
  wcReport: File | null;
  opsMaster: File | null;
  maxUploadMb: number;
  disabled: boolean;
  onWcReport: (file: File) => void;
  onClearWcReport: () => void;
  onOpsMaster: (file: File) => void;
  onClearOpsMaster: () => void;
}

/**
 * The two workbook inputs: the WC export - or nothing, once the NetSuite feed
 * is chosen - and the Ops master tracker.
 *
 * Split out of {@link ../UploadForm.view.tsx} to keep that file under its line
 * budget; markup only, same as every other view in this folder.
 *
 * @example
 * <ReceiptDropzones wcSource="upload" wcReport={null} opsMaster={null}
 *   maxUploadMb={25} disabled={false} onWcReport={setWc} onClearWcReport={clearWc}
 *   onOpsMaster={setOps} onClearOpsMaster={clearOps} />
 */
export function ReceiptDropzones(props: ReceiptDropzonesProps) {
  const {
    wcSource,
    wcReport,
    opsMaster,
    maxUploadMb,
    disabled,
    onWcReport,
    onClearWcReport,
    onOpsMaster,
    onClearOpsMaster,
  } = props;

  return (
    <div className={styles.dropzones}>
      {wcSource === "upload" ? (
        <FileDropzone
          label="WC item receipt report"
          hint="NetSuite Item Receipt Landed Cost Detail export"
          accept={[".xlsx"]}
          maxSizeMb={maxUploadMb}
          file={wcReport}
          onFileSelected={onWcReport}
          onFileCleared={onClearWcReport}
          disabled={disabled}
        />
      ) : (
        <Card title="WC item receipt report">
          <p className={styles.bandsHint}>
            Read from NetSuite when the run starts. Nothing to attach.
          </p>
        </Card>
      )}
      <FileDropzone
        label="Ops master workbook"
        hint="Ops / Accounting / FP&A master tracker"
        accept={[".xlsx"]}
        maxSizeMb={maxUploadMb}
        file={opsMaster}
        onFileSelected={onOpsMaster}
        onFileCleared={onClearOpsMaster}
        disabled={disabled}
      />
    </div>
  );
}
